// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalHeader_container__sYBmf","inner":"LegalHeader_inner__3uMGb"};